import { render, staticRenderFns } from "./PrimaryInformation.vue?vue&type=template&id=4a524050&scoped=true"
import script from "./PrimaryInformation.vue?vue&type=script&lang=js"
export * from "./PrimaryInformation.vue?vue&type=script&lang=js"
import style0 from "./PrimaryInformation.vue?vue&type=style&index=0&id=4a524050&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a524050",
  null
  
)

export default component.exports